/**
 * Transportadoras del selector de manifiestos.
 * El valor es el que guarda el API.
 */
import type { ManifiestoCarrierOption } from '../../types/manifiestos'

export const MANIFIESTOS_CARRIERS: ManifiestoCarrierOption[] = [
  { id: 'envia', label: 'Envía', transportadora: 'envía' },
  { id: 'coordinadora', label: 'Coordinadora', transportadora: 'coordinadora' },
  { id: 'interrapidisimo', label: 'Interrapidisimo', transportadora: 'inter_rapidisimo' },
  { id: 'homedelivery', label: 'Homedelivery', transportadora: 'home_delivery' },
  { id: 'falabella', label: 'Falabella', transportadora: 'falabella' },
  { id: 'meli', label: 'Mercadolibre', transportadora: 'meli' },
]

export function carrierLabel(transportadora: string | undefined): string {
  if (!transportadora) return ''
  const found = MANIFIESTOS_CARRIERS.find(
    (item) => item.transportadora === transportadora
  )
  return found?.label || transportadora
}
